module.exports = __webpack_public_path__ + "static/media/di32.8242c049.pdf";